export const UPDATE_FLIGHT_OFFERS = 'UPDATE_FLIGHT_OFFERS'
export const REMOVE_FLIGHT = 'REMOVE_FLIGHT'

export const updateFlightOffers = data => {
  return {
    type: UPDATE_FLIGHT_OFFERS,
    data,
  }
}

export const removeFlight = (routeId, flightId) => {
  return {
    type: REMOVE_FLIGHT,
    data: {
      routeId,
      flightId,
    },
  }
}
